import React, { FC } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import { format, ddayjs } from '@dt/fe-utils'
import { formatCardNumber, checkExpire } from '@utils'
import mktController from 'controllers/mktController'
import { CardShape } from 'pages/mkt/components'
import './index.scss'

interface IProps {
  cardInfo: any;
}

const UnavailableCardItem: FC<IProps> = (props) => {
  const { cardInfo } = props

  const getExpire = () => {
    return cardInfo && cardInfo.expireTime !== null && checkExpire(cardInfo.expireTime, ddayjs('brand').format('YYYY-MM-DD HH:mm:ss'))
  }

  return (
    <>
      <div className='mkt-unavailable-card-item'>
        <div className='item-area'>
          <div className='mgci-header'>
            <div className={`mgci-header-l${(!cardInfo?.extra?.shape || cardInfo?.extra?.shape === 'rectangle') ? ' rectangle' : ''}`}>
              <CardShape cardFace={mktController.getGiftCardCover(cardInfo)} shape={cardInfo?.extra?.shape || 'rectangle'} isScale={false}></CardShape>
            </div>
            <div className='mgci-header-r'>
              <div className='title'>{cardInfo.giftcard.giftcardName}</div>
              <div className='number'>{format.toPrice(cardInfo.balance)}</div>
            </div>
          </div>
          <div className='mgci-content'>
            <div className='mgci-content-l'>{formatCardNumber(cardInfo.cardNo)}</div>
            <div className='mgci-content-r'>
              {
                cardInfo.status === 'disable' ? <span>{i18n.t('mkt.giftCard.frozen')}</span> : (
                  <>
                    {
                      cardInfo.expireTime &&
                        <>
                          {getExpire() ? <span>{i18n.t('mkt.giftCard.status_expired')}</span> : <span>{format.toDateTime(cardInfo.expireTime)}</span>}
                        </>
                    }
                    {!cardInfo.giftcard.allowAgainLoad && <span>{i18n.t('mkt.member.noRecharge')}</span>}
                  </>)
              }
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default observer(UnavailableCardItem)
